<template>
  <Modal width="80%" v-model="isShowModal" :title="modalTitle">
    <Table
      v-if="editType != 'qn'"
      border
      :columns="modalTableColumns"
      :data="modalTableData"
      style="margin: 20px 0"
      height="200"
    >
    </Table>
    <DynamicFixedTable
      :key="scoreFlagKey"
      v-if="editType == 'qn'"
      :view-data="newPotentialScoreList"
      :previewMode="isShowView"
      :disableMode="
        editItem.bePotentialSubmit == '1' || $route.query.beEnd == '1' || editItem.beFlag == '0'
      "
      :perviewInfo="scoreInfo"
      :lang="lang"
      :i18="$t"
      @onChange="isShowView = false"
    />
    <Spin size="large" fix v-if="loading" />
    <div slot="footer">
      <Button
        type="info"
        v-if="editType == 'qn'"
        @click="viewNewPotentialScore()"
        ><!-- 预览结果 -->{{ $t('PreviewResults') }}</Button
      >
      <Button
        type="warning"
        v-if="editType == 'qn' && editItem.id && isShowPrePotential"
        @click="viewPrePotentialScore()"
        ><!-- 上年度结果 -->{{ '上年度结果' }}</Button
      >
      <Button v-if="editItem.bePotentialSubmit != '1' && editItem.beFlag != '0' && editType == 'qn' && $route.query.beEnd != '1'" @click="onModalConfirm()"
        ><!-- 保存 -->{{ $t("Confirm") }}</Button
      >
    </div>
    <PotentialRangeByPre ref="PotentialRangeByPreRef" @copyData="copyData"/>
  </Modal>
</template>
<script>
import DynamicFixedTable from "./PotentialRangeComponents/DynamicFixedTable.vue";
import PotentialRangeByPre from "./PotentialRangeByPre.vue";
export default {
  components: { DynamicFixedTable,PotentialRangeByPre },
  data() {
    return {
      editType: "",
      editItem: {},
      isShowModal: false,
      modalTitle: "",
      modalTableColumns: [],
      modalTableData: [],
      loading: false,
      scoreInfo: {},
      isShowView: false,
      newPotentialScoreList: [],
      scoreFlagKey: false,
      isShowPrePotential: true //是否显示上年度结果
    };
  },
  computed: {
    overallTableColumns() {
      return [
        {
          title: this.$t('Year'), // "年度",
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t('WHAT_Assessment_PPT'),
          key: this.lang == "zh" ? "whatScoreName" : "wholeScoreEName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t('HOW_Assessment_PPT'),
          key: this.lang == "zh" ? "howScoreName" : "howScoreEName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t('Overall_Assessment_PPT'),
          key: this.lang == "zh" ? "wholeScoreName" : "wholeScoreEName",
          align: "center",
          minWidth: 100,
        },
      ];
    },
    qnTableColumns() {
      return [
        {
          title: "年度",
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: "潜能评分",
          key: "potentialScore",
          align: "center",
          minWidth: 100,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  methods: {
    copyData(e) {
      this.newPotentialScoreList = e
      this.scoreFlagKey = !this.scoreFlagKey
    },
    viewPrePotentialScore() {
      this.$refs.PotentialRangeByPreRef.onEditItem(this.editItem);
    },
    viewNewPotentialScore() {
      this.axios
        .post("/achReport/viewNewPotentialScore", this.newPotentialScoreList)
        .then((res) => {
          if (res) {
            this.scoreInfo = res || {};
            this.isShowView = true;
          }
        });
    },
    onModalConfirm() {
      this.$Modal.confirm({
        title: this.$t("sureAboutOperation"),
        onOk: () => {
          let url = "";
          let obj = {};
          if (this.editType == "qn") {
            url = "/achReport/saveNewPotentialScoreInfoList";
            obj = {
              ...this.editItem,
              potentialList: this.newPotentialScoreList,
            };
          }
          this.axios.post(url, obj).then((res) => {
            if (res) {
              this.onCloseModal();
              this.$emit("onSetScore", {
                score: res,
                potentialList: this.newPotentialScoreList,
              });
            }
          });
        },
      });
    },
    onCloseModal() {
      this.isShowModal = false;
    },
    onEditItem(row, type) {
      this.editItem = JSON.parse(JSON.stringify(row));
      this.editType = type;
      this.isShowModal = true;
      this.isShowView = false;
      if (type == "overall") {
        this.modalTitle =
          this.$t("movment") +
          "-" +
          (this.editItem.userName || '') +
          "/" +
          (this.editItem.userEName || '');
        if(!this.editItem.id) {
          this.modalTitle =
          this.$t("movment")
        }
        this.modalTableColumns = this.overallTableColumns;
      } else {
        this.modalTableColumns = this.qnTableColumns;
        this.modalTitle =
          this.$t("Potential") +
          "-" +
          (this.editItem.userName || '') +
          "/" +
          (this.editItem.userEName || '');
        if(!this.editItem.id) {
          this.modalTitle =
          this.$t("Potential")
        }
      }
      this.getData();
    },
    getData() {
      let url = "";
      let obj = {};
      if (this.editType == "qn") {
        url = "/achReport/searchNewPotentialScoreInfoList";
        obj = {
          id: this.editItem.id,
          isPBFlag: this.editItem.isPBFlag,
          isApprovalFlag: this.editItem.isApprovalFlag,
          serialnumber: this.editItem.serialnumber,
          year: this.editItem.year,
        };
      }
      if (this.editType == "overall") {
        url = "/AchPeopleBoard/searchPerformanceTrends";
        obj = {
          serialnumber: this.editItem.serialnumber,
          year: this.editItem.year,
        };
      }
      this.loading = true;
      this.axios.post(url, obj).then((res) => {
        this.loading = false;
        if (this.editType == "qn") {
          this.modalTableData = res.interviewInfoList || [];
          this.newPotentialScoreList = res.newPotentialScoreList || [];
        }
        if (this.editType == "overall") {
          this.modalTableData = res || [];
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
>>> .ivu-modal-body {
  height: 100% !important;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialRange.vue